var styles = {
  "menu": "_menu_2xnl4e_1"
};
export { styles as default };
